import { logger } from '@lusha/client-logger';

import AjaxUtils from './ajaxUtils';

export const saveContactToWishlist = async contactsData => {
  try {
    return await AjaxUtils.post('/v2/wished-contacts', contactsData);
  } catch (error) {
    logger.error('Failed to post wishlist contact data ', error);

    return undefined;
  }
};

export const updateWishedContact = async ({ contactId, data }) => {
  try {
    return await AjaxUtils.patch(`/v2/wished-contacts/${contactId}`, data);
  } catch (error) {
    logger.error('Failed to update wishlist contact data ', error);

    return undefined;
  }
};
